import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const langs = [
    { code: 'en', label: 'EN' },
    { code: 'nl', label: 'NL' },
    { code: 'es', label: 'ES' },
  ];

  return (
    <div className="flex items-center gap-1" data-testid="language-toggle">
      {langs.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLanguage(l.code)}
          className={`lang-btn ${language === l.code ? 'active' : ''}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
